import React, { useState } from "react"
import { Dialog, Box, DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"

import TextInput from "components/Forms/TextInput"
import ChangeAmountButton from "components/Buttons/ChangeAmountButton"

import useInputValue from "@secureo/common/hooks/useInputValue"
import Button from "components/Buttons/Button"

const useStyles = makeStyles()(() => ({
	dialog: {
		backgroundColor: "rgba(#424242, 0.2)",
	},
}))

const LockingSystemQuickStart = ({
	closeModal,
	setLockingSystemName,
	createInitialComponents,
	startTourGuideIfHasNotBeenCompleted,
}: Props) => {
	const { classes } = useStyles()
	const name = useInputValue("")
	const [numberOfLockingComponents, setNumberOfLockingComponents] = useState(1)
	const [numberOfKeyComponents, setNumberOfKeyComponents] = useState(1)

	const closeModalAndOpenTourGuide = () => {
		startTourGuideIfHasNotBeenCompleted()

		closeModal()
	}

	const onSave = () => {
		if (name.value.length > 0) setLockingSystemName(name.value)

		createInitialComponents(numberOfLockingComponents, numberOfKeyComponents)
		closeModalAndOpenTourGuide()
	}

	return (
		<Dialog
			className={classes.dialog}
			onClose={closeModalAndOpenTourGuide}
			aria-labelledby="quick-start"
			open
			fullWidth
			maxWidth="xs"
		>
			<DialogTitle>
				<span style={{ margin: 0, fontWeight: 700 }}>Erstellen Sie Ihre Schließanlage</span>
			</DialogTitle>
			<DialogContent>
				<div>
					<strong>Geben Sie Ihrer Anlage einen Namen</strong>
				</div>
				<Box style={{ maxWidth: 300 }}>
					<TextInput
						name="locking-system-name"
						label="Geben Sie Ihrer Anlage einen Namen"
						placeholder="Schließanlagenname"
						{...name}
						fullWidth
					/>
				</Box>
				<Box my={3}>
					<Grid container spacing={3}>
						<Grid item xs={6}>
							<div>
								<strong>Anzahl Türen</strong>
							</div>
							<ChangeAmountButton
								quantity={numberOfLockingComponents}
								onChange={(quanity) => {
									setNumberOfLockingComponents(quanity)
								}}
								minQuantity={1}
							/>
						</Grid>
						<Grid item xs={6}>
							<div>
								<strong>Anzahl Schlüsselgruppen</strong>
							</div>
							<ChangeAmountButton
								quantity={numberOfKeyComponents}
								onChange={(quanity) => {
									setNumberOfKeyComponents(quanity)
								}}
								minQuantity={1}
							/>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
			<DialogActions
				style={{ background: "#EDEFF0", display: "flex", justifyContent: "space-between" }}
			>
				<Button
					onClick={closeModalAndOpenTourGuide}
					style={{ maxWidth: 190, float: "left" }}
				>
					Abbrechen
				</Button>
				<Button color="primary" onClick={onSave} style={{ maxWidth: 250 }}>
					Schließanlage erstellen
				</Button>
			</DialogActions>
		</Dialog>
	)
}

interface Props {
	closeModal: () => void
	setLockingSystemName: (name: string) => void
	createInitialComponents: (
		numberOfLockingComponents: number,
		numberOfKeyComponents: number,
	) => void
	startTourGuideIfHasNotBeenCompleted: () => void
}

export default LockingSystemQuickStart
